import IDENTITY_TYPE_OPTS from '../constants/defaultIdentityTypeOpts';
import { isCountryVietnam } from '../constants/countries';
import { isForeignCompany } from './companies';

export const getIdentityTypeOpts = (auth, identityPresets) => {
  const isVietnam = isCountryVietnam(auth && auth.company && auth.company.countryCode);
  let identityTypeOpts = IDENTITY_TYPE_OPTS;
  if (isVietnam) {
    const cccdTypeOpt = identityTypeOpts.find(o => o.value === 1);
    if (cccdTypeOpt) {
      cccdTypeOpt.text = 'CCCD';
    }
    // CPI-976: Vietnam's identity types are CCCD, Passport and Enterprise Registration Certificate
    // (value 4, relabelled). Mapped into a new object - the constant is shared.
    identityTypeOpts = identityTypeOpts
      .filter(o => o.value !== 3)
      .map(o => (o.value === 4 ? { ...o, text: 'Enterprise Registration Certificate' } : o));
  } else if (auth && isForeignCompany(auth.company)) {
    // remove NRIC & Military/Police identities
    identityTypeOpts = identityTypeOpts.filter(o => o.value !== 1 && o.value !== 3);
    // check for new identity presets
    if (identityPresets && identityPresets.length > 0) {
      identityTypeOpts = [...identityTypeOpts, ...identityPresets.map(i => ({ text: i.label, value: i.id, 'data-regex': i.regex }))];
    }
  }

  return identityTypeOpts;
};



// WEBPACK FOOTER //
// ./src/utils/identityTypes.js